import { type FC } from "react";
import {
  StyledRectangleContainer,
  StyledRectangleChildContainer,
  StyledContainer,
} from "./styled";

const CardGridViewPlaceholder: FC = () => {
  return (
    <StyledContainer>
      <Rectangle />
      <Rectangle />
      <Rectangle />
      <Rectangle />
      <Rectangle />
    </StyledContainer>
  );
};

const Rectangle: FC = () => {
  return (
    <StyledRectangleContainer>
      <StyledRectangleChildContainer
        width={11}
        height={3}
        bgColor="rgba(0, 0, 0, 0.40)"
      />
      <StyledRectangleChildContainer
        width={17}
        height={2}
        bgColor="rgba(0, 0, 0, 0.20);"
      />
      <StyledRectangleChildContainer
        width={15}
        height={2}
        bgColor="rgba(0, 0, 0, 0.20)"
      />
      <StyledRectangleChildContainer
        width={10}
        height={2}
        bgColor="rgba(0, 0, 0, 0.20)"
      />
    </StyledRectangleContainer>
  );
};

export default CardGridViewPlaceholder;
